import { useState, useEffect, useCallback } from 'react';
import { getDoctors } from '../services/api/apis';
import type { Doctor } from '../types';

interface UseDoctorListReturn {
  doctors: Doctor[];
  isLoading: boolean;
  error: string | null;
  refresh: () => void;
}

export const useDoctorList = (): UseDoctorListReturn => {
  const [doctors, setDoctors] = useState<Doctor[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const data = await getDoctors();
      setDoctors(data);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load doctors');
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return { doctors, isLoading, error, refresh: load };
};
